import { render, staticRenderFns } from "./pagosMasivo.vue?vue&type=template&id=52353830"
import script from "./pagosMasivo.vue?vue&type=script&lang=js"
export * from "./pagosMasivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports